import React from "react";

import { Link } from "react-router-dom";

import { Row } from "react-bootstrap";

import Icon from "components/Icons/Icon";

import { withT } from "services/translation/";

import IntegrationList from "./IntegrationList/";

function ManageIntegrations({ onBackToOverview, t }) {
  return (
    <>
      <Row className="px-2 mt-2">
        <div className="btn btn-default border-none side-pane-back text-dark">
          <Link to="#" onClick={onBackToOverview}>
            <span className="back-to-overview"><Icon className="fas fa-chevron-left mr-2" /> {t("back_to_overview")}</span>
          </Link>
        </div>
      </Row>

      <div className="row px-2 mt-3">
        <div className="col-md-12">
          <IntegrationList />
        </div>
      </div>
    </>
  );
}

export default withT(
  ManageIntegrations,
  "site_overview.side_pane.manage_integrations"
);
